export const muiInputLabel = {
    styleOverrides:{
        root: {
            top: '-6px'
        }
    }
}